export enum TitleType {
  Movie = "Movie",
  Season = "Season",
}
